import { Programme } from '@edwin-group/cj-graphql';
import { useCallback, useMemo } from 'react';
import ProgrammeCard from '@/components/Card/Programme';
import DefaultContentTemplateTags from '@/components/DefaultContentTemplate/Tags';
import { useNavigate } from 'react-router-dom';

export const Card = ({ programme, seeMissionButtonText }: { programme: Programme; seeMissionButtonText: string }) => {
  const navigate = useNavigate();

  const onSeeMissions = useCallback(
    (programme: Programme) => {
      navigate(
        `/missions?missionsDocumentIds=${programme.missions.map((mission) => mission!.documentId).join(',')}&programmeName=${encodeURIComponent(programme.name)}`,
      );
    },
    [navigate],
  );

  const onPressPlay = () => {
    onSeeMissions(programme);
  };

  const tags = useMemo(
    () =>
      (programme.missions ?? [])
        .filter(Boolean)
        .flatMap((mission) => mission?.keyStage ?? [])
        .filter((ks) => ks?.keyStage)
        .filter((ks, idx, arr) => {
          const norm = (s: string) => s.trim().toLowerCase();
          const key = norm(ks!.keyStage!);
          return arr.findIndex((k2) => k2?.keyStage && norm(k2.keyStage) === key) === idx;
        })
        .map((ks) => (
          <DefaultContentTemplateTags
            type="PROGRAMME"
            key={ks!.keyStage!}
            tags={[ks!.keyStage!]}
            uppercase
            className="!my-0"
          />
        )),
    [programme.missions],
  );

  return (
    <ProgrammeCard
      seeMissionButtonText={seeMissionButtonText}
      programme={programme}
      tags={<div className="mt-0 flex flex-wrap gap-2">{tags}</div>}
      onPressPlay={onPressPlay}
    />
  );
};
